import { render, staticRenderFns } from "./OrderDocs.vue?vue&type=template&id=5c328873&scoped=true&"
import script from "./OrderDocs.vue?vue&type=script&lang=js&"
export * from "./OrderDocs.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocs.vue?vue&type=style&index=0&id=5c328873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c328873",
  null
  
)

export default component.exports